/**
 * @generated SignedSource<<75e7fdbe29e30c7135bd66900fbf7dce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SkillLevelRow_skillLevel$data = {
  readonly id: string;
  readonly level: number | null;
  readonly description: string | null;
  readonly " $fragmentType": "SkillLevelRow_skillLevel";
};
export type SkillLevelRow_skillLevel$key = {
  readonly " $data"?: SkillLevelRow_skillLevel$data;
  readonly " $fragmentSpreads": FragmentRefs<"SkillLevelRow_skillLevel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillLevelRow_skillLevel",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "SkillLevel",
  "abstractKey": null
};

(node as any).hash = "a4dd7698bbb1179e95dd2ee513b5e6aa";

export default node;
